<ul class="p-reset">
  <li [class.mb-2]="i < updates?.length - 1" *ngFor="let update of updates; index as i">
    <span>{{ update.date | appDateTime: {} : language }} — {{ update.version }}</span>
    <ul class="p-reset ml-4">
      <div [innerHTML]="update.changes | safe: 'html'"></div>
    </ul>
  </li>
</ul>
